module.exports = __webpack_public_path__ + "static/assets/76f05fc6c6d5bd694d13a4da81ee10bd.png";